export enum ECovers {
    studentcovers = 'STUDENT COVER',
    cover_golf = 'GOLF',
    cover_travel = 'TRAVEL',
    cover_motor = 'MOTOR',
    cover_domestic = 'DOMESTIC',
    cover_personalaccident = 'PERSONAL ACCIDENT',
    traumacare  = 'TRAUMACARE',
    cover_medical = 'MEDICAL'
}